var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-160v-640l760 320zm60-93 544-227-544-230v168l242 62-242 60zm0 0v-457z"
  })));
};
export default SvgSend;